import React, { useContext } from "react";
import ManagerReportContext from "../../../Context/ManagerReportContext/ManagerReportContext";
import "./ManagerReportsStyle.css";

export default function ManagerReportPagination({ handleNextPrev, nextPage }) {
  const { allData } = useContext(ManagerReportContext);
  const currentPage = parseInt(allData?.current_page);
  const pageSize = parseInt(allData?.page_size);
  const totalRecords = parseInt(allData?.total_records);

  const startRecord = (currentPage - 1) * pageSize + 1;
  const endRecord = Math.min(currentPage * pageSize, totalRecords);
  return (
    <div
      className="card d-flex justify-content-between w-100"
      style={{ borderTopLeftRadius: "0", borderTopRightRadius: "0" }}
    >
      <nav className="pagination-nav" aria-label="Page navigation example">
        <div className="wid-20"></div>
        <ul className="pagination pb-7">
          {nextPage.currentPage - 1 ? (
            <>
              <li className="page-item">
                <button
                  className={
                    nextPage.currentPage - 1
                      ? "page-link"
                      : "page-link disabled"
                  }
                  onClick={() => {
                    handleNextPrev("prev");
                  }}
                >
                  Prev
                </button>
              </li>
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => {
                    handleNextPrev("prev");
                  }}
                >
                  {nextPage.currentPage - 1}
                </button>
              </li>
            </>
          ) : null}
          {}
          <li className="page-item">
            <button className="btn btn-primary btn-sm" href="#">
              {nextPage.currentPage}
            </button>
          </li>
          {nextPage.nextPage ? (
            <>
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => {
                    handleNextPrev("next");
                  }}
                >
                  {nextPage.currentPage + 1}
                </button>
              </li>
              <li className="page-item">
                <button
                  disabled={!nextPage.nextPage}
                  className={
                    nextPage.nextPage ? "page-link" : "page-link disabled"
                  }
                  onClick={() => {
                    handleNextPrev("next");
                  }}
                >
                  Next
                </button>
              </li>
            </>
          ) : null}
        </ul>

        <div className="page-item wid-20 ml-auto pt-2 ">
          <span className="text-record">
            <b>Page-records:</b> {startRecord}-{endRecord} / {totalRecords}
          </span>
        </div>
      </nav>
    </div>
  );
}
